export const INFORMATION_PENDING = undefined;
export const RETRY = 'incomplete';
export const DOCUMENT = 'document';
export const DOCUMENT_PENDING = 'document_pending';
export const VERIFIED = 'verified';
